// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2iDJq","tab":"Tabs_tab__3HR1U","tabActive":"Tabs_tabActive__2OIVS"};